module.exports = {
    contentUri: "http://local.playco.com:8800",
    apiUri: "https://dev-api.aws.playco.com/api/v1.0/",
    allowedDomains: [
        ".playco.com",
        "localhost",
        "starzplay.local"
    ],
    sessionStorageKey: "SPConf",
    googleAnalyticsId: 'UA-52364929-30'
};



// WEBPACK FOOTER //
// ./src/config/development.js